export type CheckInReaderDisplaySource = {
  readerDeviceName?: string | null;
  readerEndpointName?: string | null;
  readerEndpointIdentifier?: string | null;
};

export function formatCheckInReader(row: CheckInReaderDisplaySource): string {
  const deviceName = (row.readerDeviceName || "").trim();
  const endpointName = (row.readerEndpointName || "").trim();
  const endpointIdentifier = (row.readerEndpointIdentifier || "").trim();
  const endpoint = endpointName || endpointIdentifier;
  if (deviceName && endpoint) return `${deviceName} · ${endpoint}`;
  return deviceName || endpoint || "–";
}
